import React from "react";

import { DialogHeading, DialogSubheading, Heading, Icon, Layout } from "@swa-ui/core";
import i18n from "@swa-ui/locale";

import styles from "./MissingInformationSaveStatus.module.scss";

export const MissingInformationSaveStatus = (props) => {
  const { accountNumber, missingInformation, unsavedInformation } = props;

  return (
    <Layout {...getLayoutProps()}>
      <span style={{ alignItems: "center", display: "flex" }}>
        {unsavedInformation && <Icon {...getHeadingErrorIconProps()} />}

        <DialogHeading className={unsavedInformation ? styles.headingError : ""}>
          {i18n(
            unsavedInformation
              ? "MissingInformationSaveStatus__HEADING_ERROR"
              : "MissingInformationSaveStatus__HEADING_SUCCESS"
          )}
        </DialogHeading>
      </span>

      {unsavedInformation && (
        <DialogSubheading>
          <p>{i18n("MissingInformationSaveStatus__SUBHEADING")}</p>
        </DialogSubheading>
      )}

      <Layout bottom="xlarge" top="xlarge">
        <div className={styles.accountNumberLabel}>
          {i18n("MissingInformationSaveStatus__ACCOUNT_NUMBER")}
        </div>
        <div className={styles.accountNumber}>{accountNumber}</div>
      </Layout>

      <Layout bottom="xlarge" top="xlarge">
        <Heading styleLevel={4}>
          {i18n(
            unsavedInformation
              ? "MissingInformationSaveStatus__UPDATES"
              : "MissingInformationSaveStatus__WHATS_CHANGED"
          )}
        </Heading>
        {missingInformation.map((missingItem) => (
          <div key={missingItem} className={styles.missingItem}>
            <Icon {...getMissingItemIconProps(missingItem)} />
            {i18n(`MissingInformationSaveStatus__${missingItem}`)}
          </div>
        ))}
      </Layout>
    </Layout>
  );

  function getLayoutProps() {
    return {
      bottom: "medium",
      className: styles.container,
      left: "medium",
      right: "medium",
      top: "medium",
    };
  }

  function getHeadingErrorIconProps() {
    return {
      className: styles.headingErrorIcon,
      color: "missing-information-error",
      name: "Error",
      size: "size36",
    };
  }

  function getMissingItemIconProps(missingItem) {
    return {
      className: styles.missingItemIcon,
      color: unsavedInformation?.includes(missingItem)
        ? "missing-information-error"
        : "missing-information-success",
      name: unsavedInformation?.includes(missingItem) ? "Close" : "Check",
      size: "size18",
    };
  }
};
